import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';
import UnderlinedText from '@marketing/components/underlined_text';

import BhavinHeadshot from './assets/bhavin_headshot.png';
import ChrisHeadshot from './assets/chris_headshot.png';
import KevinHeadshot from './assets/kevin_headshot.png';
import KristinHeadshot from './assets/kristin_headshot.png';
import LucasHeadshot from './assets/lucas_headshot.png';
import MikeHeadshot from './assets/mike_headshot.png';
import StarIcon from './assets/star_icon.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l" style={{ position: 'relative' }}>
      <SectionHeader
        subtitle="Learn from teachers who know the SAT inside and out."
        supertitle="Expert teachers"
        supertitleIcon={StarIcon}
        title={<>Our instructors are test prep <UnderlinedText color={colors.brandSecondary}>experts</UnderlinedText></>}
      />

      <div className="d-flex flex-column flex-lg-row flex-lg-wrap gap-m">
        <InstructorCard
          avatar={ChrisHeadshot}
          name="Chris Lele"
        >
          Chris Lele is a UCLA graduate with more than 10 years of experience tutoring math and verbal for the SAT. He has coached many students to perfect scores.
        </InstructorCard>

        <InstructorCard
          avatar={MikeHeadshot}
          name="Mike McGarry"
        >
          Mike McGarry has a BS and an MA from Harvard. He also has more than 20 years of teaching experience specializing in math, science and standardized exams.
        </InstructorCard>

        <InstructorCard
          avatar={LucasHeadshot}
          name="Lucas Fink"
        >
          Lucas Fink studied creative writing at Bard College and has been teaching English grammar and standardized tests, two of his greatest passions, since 2008.
        </InstructorCard>

        <InstructorCard
          avatar={KristinHeadshot}
          name="Kristin Fracchia"
        >
          Kristin Fracchia has a PhD from UC Irvine and degrees in Education and English. She’s been helping students prepare for standardized tests for over 8 years.
        </InstructorCard>

        <InstructorCard
          avatar={KevinHeadshot}
          name="Kevin Rocci"
        >
          Kevin Rocci graduated from UC Santa Cruz. He has been tutoring standardized tests and teaching English in the US and Japan for more than 12 years.
        </InstructorCard>

        <InstructorCard
          avatar={BhavinHeadshot}
          name="Bhavin Parikh"
        >
          Bhavin Parikh got his bachelor’s degree from Duke and an MBA at UC Berkeley. He is committed to making Magoosh the best study experience possible.
        </InstructorCard>
      </div>
    </div>
  );
};

interface InstructorCardProps {
  avatar: string;
  children: any;
  name: string;
}

const InstructorCard = (props: InstructorCardProps) => {
  return (
    <Card
      className={cx(styles.instructorCard, 'd-flex flex-column gap-m')}
    >
      <div className="align-items-center d-flex flex-row gap-s">
        <div>
          <img alt={`Image of ${props.name}`} height="56px" loading="lazy" src={props.avatar} width="56px" />
        </div>

        <div className="text-inter"><strong>{props.name}</strong></div>
      </div>

      <div className="text-inter text-medium">
        {props.children}
      </div>
    </Card>
  );
};
